import { render, staticRenderFns } from "./ThemeQuestions.vue?vue&type=template&id=84c4000e&scoped=true&"
import script from "./ThemeQuestions.vue?vue&type=script&lang=js&"
export * from "./ThemeQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ThemeQuestions.vue?vue&type=style&index=0&id=84c4000e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c4000e",
  null
  
)

export default component.exports